import { ReactNode } from 'react'
import { VMHAStatusDetails } from 'api-client/model'

export enum RebalancingStrategy {
  VMWorkloadConsolidation = 'vm_workload_consolidation',
  NodeResourceConsolidation = 'node_resource_consolidation',
}

export enum Status {
  Healthy = 'Active',
  Unhealthy = 'Inactive',
  Maintenance = 'Maintenance',
  Error = 'Error',
  Unknown = 'Unknown',
}

export enum RebalancingFrequency {
  Default = 20,
  Aggressive = 10,
  Conservative = 30,
}

export interface AutoResourceRebalancing {
  enabled: boolean
  rebalancingStrategy: RebalancingStrategy
  rebalancingFrequencyMins: number
}

export interface VMHighAvailability {
  enabled: boolean
}

export interface Gpu {
  enabled: boolean
  mode: string
}

export interface Cpu {
  mode: string
  model: string
}

export interface CreateClusterHostGroup {
  name: string
  vmHighAvailability: VMHighAvailability
  autoResourceRebalancing: AutoResourceRebalancing
  gpu: Gpu
  cpu: Cpu
}

export enum VMHADisplayStatus {
  PROTECTED = 'Protected',
  NOT_PROTECTED = 'Not Protected',
  DEGRADED = 'Degraded',
  DISABLED = 'Disabled',
  UNKNOWN = 'Unknown',
  LOADING = 'Loading',
}

export interface VMHACondition {
  key: string
  label: string | ReactNode
  passed?: boolean
  degraded?: boolean
}

export type EditClusterHostGroup = Omit<CreateClusterHostGroup, 'cpu'>

export interface ClusterHostGroup {
  id?: string
  name: string
  vmHighAvailability: VMHighAvailability
  autoResourceRebalancing: AutoResourceRebalancing
  hostlist: string[]
  status: Status
  gpu?: Gpu
  cpu?: Cpu
}

export interface IClusterHostGroup extends ClusterHostGroup {
  vmhaStatus?: VMHADisplayStatus
  vmhaState?: VMHAStatusDetails
  hosts?: Array<any>
  physicalNetworkLabels: string[]
  totalUsage: {
    cpuUsage: {
      current: number
      total: number
    }
    memoryUsage: {
      current: number
      total: number
    }
    storageUsage: {
      current: number
      total: number
    }
  }
}
